import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import { setActiveLanguage, getTranslate, getActiveLanguage } from 'react-localize-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faSearch } from '@fortawesome/pro-regular-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import * as QueryString from "query-string"
import slugify from 'slugify';

import { signout } from '../../actions/auth/index';
import { showAuthenticationPopup, showResponsiveMenu, toggleResponsiveMenu } from '../../actions/common/index';
import { setSort, setFilter } from '../../actions/material/index';

import HeaderCart from '../shopping-cart/HeaderCart';

// import SelectBox from '../form/SelectBox';
import HeaderMegaMenu from './HeaderMegaMenu';
// import Store from '../../store';
// import {AUTH_USER} from '../../actions/auth/type';
// import {GET_PROFILE} from '../../actions/profile/type';
import { closeTerm, search } from '../../actions/search/index';
import { setLanguagePreference } from '../../actions/profile/index';
import { getUserNotification, updateUserNotification } from '../../actions/notification/index';
import { moneyFormat, gtm, pixelTrack } from '../../assets/util';
// import searchIcon from '../../assets/icon/search.svg'
import IconAccount from '../../assets/icon/IconAccount';
import IconHamburger from '../../assets/icon/IconHamburger';
import '../../assets/beautrium-css/header.scss'
import { ACCOUNT_MENU } from '../../assets/menu';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            direction: '',
            lastScrollPos: 0,

            currLangPopupVisible: false,
            shopMenuVisible: false,
            searchVisible: false,
            accountMenuVisible: false,
            searchCompleteVisible: false,
            bigAnnounceBarVisible: true,
            keyword: '',
            // event_bar: false,
        }

        this.currLangPopupHandleClick = this.currLangPopupHandleClick.bind(this);
        this.currLangPopupHandleOutsideClick = this.currLangPopupHandleOutsideClick.bind(this);
        this.megaMenuHandleClick = this.megaMenuHandleClick.bind(this);
        this.megaMenuHandleOutsideClick = this.megaMenuHandleOutsideClick.bind(this);
        this.searchHandleClick = this.searchHandleClick.bind(this);
        this.searchHandleOutsideClick = this.searchHandleOutsideClick.bind(this);
        this.searchCompleteHandleClick = this.searchCompleteHandleClick.bind(this);
        this.searchCompleteHandleOutsideClick = this.searchCompleteHandleOutsideClick.bind(this);
        this.accountMenuHandleClick = this.accountMenuHandleClick.bind(this);
        this.accountMenuHandleOutsideClick = this.accountMenuHandleOutsideClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        // this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.setKeyword = this.setKeyword.bind(this);
        this.renderCloseTermsv2 = this.renderCloseTermsv2.bind(this);
        // this.setReadNotice = this.setReadNotice.bind(this);
        this.searchTracking = this.searchTracking.bind(this)

        this.handleMouseLeave = _.debounce(((value) => { this.setState({ shopMenuVisible: value }) }), 200);

        this._setKeyWord = _.debounce((value) => {
            this.props.closeTerm(value);
            let currentSearch = this.props.location.search;
            if (value === '' || !value) {
                this.props.history.push({ pathname: this.props.location.pathname, search: currentSearch })
            } else {
                const newSearch = QueryString.parse(currentSearch)
                newSearch.q = value
                this.props.history.push({ pathname: this.props.location.pathname, search: "?" + QueryString.stringify() })
            }
        }, 500);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true);

        // if (document.getElementById('event-bar')) {
        //     this.setState({event_bar: true})
        // }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    componentWillUpdate(nextProps, nextState) {
        if (!_.isEqual(this.props.match, nextProps.match)) {
            this.props.showAuthenticationPopup(false);
            // this.props.showTrackOrder(false);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.shopMenuVisible) {
            if (prevProps.location !== this.props.location) {
                // this.megaMenuHandleClick();
                this.setState({ shopMenuVisible: false })
            }
        }
        if (prevState.accountMenuVisible) {
            if (prevProps.location !== this.props.location) {
                this.accountMenuHandleClick();
            }
        }
        if (prevProps.authenticated === false && this.props.authenticated === true) {
            this.props.getUserNotification();
        }
        if (prevProps.update_notice === null && this.props.update_notice === true) {
            this.props.getUserNotification();
        }
    }

    handleScroll(e) {
        const { lastScrollPos } = this.state;
        const doc = document.documentElement;
        const topPos = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (lastScrollPos > topPos) {
            this.setState({
                // direction: 'up', lastScrollPos: topPos,
                bigAnnounceBarVisible: false,
            });
        } else if (lastScrollPos < topPos) {
            this.setState({
                // direction: 'down', lastScrollPos: topPos,
                bigAnnounceBarVisible: false,
            });
        }
        if (topPos === 0) {
            this.setState({
                bigAnnounceBarVisible: true,
            })
        }
    }

    searchTracking(clickResult = false) {
        const v = this.state.keyword;
        if (v !== '') {
            gtm('search', { search_term: v })
            pixelTrack("Search", { search_string: v })
        }
    }

    currLangPopupHandleClick() {
        if (!this.state.currLangPopupVisible) {
            document.addEventListener('click', this.currLangPopupHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.currLangPopupHandleOutsideClick, false);
        }

        this.setState(prevState => ({
            currLangPopupVisible: !prevState.currLangPopupVisible,
        }))

    }

    currLangPopupHandleOutsideClick(e) {
        if (this.node.contains(e.target)) {
            return;
        }
        this.currLangPopupHandleClick();
    }

    megaMenuHandleClick() {
        if (!this.state.shopMenuVisible) {
            document.addEventListener('click', this.megaMenuHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.megaMenuHandleOutsideClick, false);
        }

        this.setState(prevState => ({
            shopMenuVisible: !prevState.shopMenuVisible
        }))
    }

    megaMenuHandleOutsideClick(e) {
        if (this.megaMenu === null || !this.megaMenu) {
            return;
        }
        if (typeof this.megaMenu.contains !== "function") {
            return;
        }
        if (this.megaMenu.contains(e.target)) {
            return;
        }
        this.megaMenuHandleClick();
    }

    searchHandleClick() {
        if (!this.state.searchVisible) {
            document.addEventListener('click', this.searchHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.searchHandleOutsideClick, false);
        }

        this.setState(prevState => ({
            searchVisible: !prevState.searchVisible,
        }));
        this.searchTracking(true)
        this.setKeyword("");

    }

    searchHandleOutsideClick(e) {
        if (!this.searchBox) {
            this.searchHandleClick()
        }
        if (this.searchBox.contains(e.target)) {
            return;
        }
        this.searchHandleClick();
    }

    searchCompleteHandleClick(e) {
        if (e) {
            e.stopPropagation()
        }
        if (!this.state.searchCompleteVisible) {
            document.addEventListener('click', this.searchCompleteHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.searchCompleteHandleOutsideClick, false);
        }
        this.searchTracking()
        this.setState(prevState => ({
            searchCompleteVisible: !prevState.searchCompleteVisible,
        }));
    }

    searchCompleteHandleOutsideClick(e) {
        if (this.searchContainer.contains(e.target)) {
            return;
        }
        this.searchCompleteHandleClick();
    }

    accountMenuHandleClick() {
        if (!this.state.accountMenuVisible) {
            document.addEventListener('click', this.accountMenuHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.accountMenuHandleOutsideClick, false);
        }

        this.setState(prevState => ({
            accountMenuVisible: !prevState.accountMenuVisible
        }))
    }

    accountMenuHandleOutsideClick(e) {
        if (!this.accountBox) {
            return;
        }
        if (this.accountBox.contains(e.target)) {
            return;
        }
        this.accountMenuHandleClick();
    }

    setKeyword(keyword) {
        let setStateObject = { keyword }
        if (!this.state.searchCompleteVisible) {
            this.searchCompleteHandleClick()
        }
        this.setState(setStateObject);
        this._setKeyWord(keyword);


        // this.props.closeTerm(keyword);
    }

    generateHighlightedText(text, regions) {
        if (!regions) return text;

        var content = '', nextUnhighlightedRegionStartingIndex = 0;

        regions.forEach(function (region) {
            content += '' +
                text.substring(nextUnhighlightedRegionStartingIndex, region[0]) +
                '<b>' +
                text.substring(region[0], region[1] + 1) +
                '</b>' +
                '';
            nextUnhighlightedRegionStartingIndex = region[1] + 1;
        });

        content += text.substring(nextUnhighlightedRegionStartingIndex);

        return content;
    };

    renderCloseTermsv2(closeTerms) {
        if (typeof closeTerms === "undefined" || !closeTerms || closeTerms.length === 0) {
            return null;
        }
        const { brands, items } = closeTerms;
        let html = [];
        if (brands.length > 0) {
            html.push(
                <div key="brand-search">
                    <h2 className="search-header-category">แบรนด์แนะนำ</h2>
                    {_.map(brands, (r, index) => {
                        const item = r
                        let link = item.shop_in_shop ? item.link_name : `/shop/${item.brand_en.replaceAll("/", "%2F")}`;

                        // const highlightedText = this.generateHighlightedText(r.matches[0].value, r.matches[0].indices);
                        // return <Link key={index} to={link} onClick={() => {this.searchHandleClick();}}><li dangerouslySetInnerHTML={{__html: `<span>${(r.item.pretext? r.item.pretext: '') + highlightedText}</span>`}}></li></Link>
                        return (
                            <Link key={index} to={link} onClick={() => { this.searchHandleClick(); }}>
                                <li>
                                    <div className="d-flex w-100 flex-row align-items-center">
                                        <div className="mr-2">
                                            <img alt="" src={item.image} style={{ height: "50px", width: "auto" }} />
                                        </div>
                                        <div className="content">{item.brand_en}</div>
                                    </div>
                                </li>
                            </Link>
                        )
                    })}
                </div>
            );
        }
        if (items.length > 0) {
            html.push(
                <div key="item-search">
                    <h2 className="search-header-category">ผลิตภัณฑ์แนะนำ</h2>
                    {_.map(items.slice(0, window.innerWidth < 768 ? 3 : 5), (item, index) => {
                        let link = `/item/${item.mat_id}/${item.mat_var_id}`;
                        // const highlightedText = this.generateHighlightedText(r.matches[0].value, r.matches[0].indices);
                        return (
                            <Link key={index} to={link} onClick={() => {/*pixelTrack("Search", {search_string: this.state.keyword, content_ids: item.item_id, content_type: 'product'});*/ this.searchHandleClick(); }}>
                                <li>
                                    <div className="d-flex w-100 flex-row align-items-center">
                                        <div className="mr-2">
                                            <img alt="" src={item.image_1} style={{ height: "50px", width: "auto" }} />
                                        </div>
                                        <div className="content">{item.brand_en} {item.mat_name} {item.variant_name_2 || ''}</div>
                                        <div className="ml-auto price">{moneyFormat(item.net_price || item.mat_price)}</div>
                                    </div>
                                </li>
                            </Link>
                        )
                    })}
                </div>
            );
        }
        if (html.length > 0) {
            html.push(
                <div key="search-more" className="search-more">
                    <Link to={`/shop/?keyword=${this.state.keyword}`}>แสดงผลการค้นหาทั้งหมด</Link>
                </div>
            )
        }
        return html;
    }

    renderCloseTerms(closeTerms) {
        const CATS = this.props.categories;
        const { categories, brands, items } = closeTerms;
        if (typeof closeTerms === "undefined" || !closeTerms || closeTerms.length === 0) {
            return null;
        }
        let html = [];
        if (categories.length > 0) {
            html.push(
                <div key="category-search">
                    <h2 className="search-header-category">หมวดสินค้า</h2>
                    {_.map(categories, (r, index) => {
                        let link = "/shop";
                        let preClose, c1, c2, c3, cat1, cat2;
                        switch (r.table_name) {
                            case 'ERP_MatCategory_1':
                                c1 = _.find(CATS, (c) => c.cat1_id === r.cat1_id).category
                                link = link + "/" + slugify(c1, { lower: true })
                                // preClose = () => {
                                //     this.props.setFilter({cat1_id: parseInt(r.value, 10)});
                                // };
                                break;
                            case 'ERP_MatCategory_2':
                                cat1 = _.find(CATS, (c) => c.cat1_id === r.cat1_id);
                                c1 = cat1.category;
                                c2 = _.find(cat1.subCategories, (c) => c.cat1_id === r.cat1_id && c.cat2_id === r.cat2_id).category
                                link = link + "/" + slugify(c1, { lower: true }) + "/" + slugify(c2, { lower: true })
                                // preClose = () => {
                                //     this.props.setFilter({cat1_id: parseInt(r.cat1_id, 10), cat2_id: parseInt(r.cat2_id, 10)});
                                // };
                                break;
                            case 'ERP_MatCategory_3':
                                cat1 = _.find(CATS, (c) => c.cat1_id === r.cat1_id)
                                c1 = cat1.category;
                                cat2 = _.find(cat1.subCategories, (c) => c.cat1_id === r.cat1_id && c.cat2_id === r.cat2_id);
                                c2 = cat2.category;
                                c3 = _.find(cat2.subCategories, (c) => c.cat1_id === r.cat1_id && c.cat2_id === r.cat2_id && c.cat3_id === r.cat3_id).category
                                link = link + "/" + slugify(c1, { lower: true }) + "/" + slugify(c2, { lower: true }) + "/" + slugify(c3, { lower: true })
                                // preClose = () => {
                                //     this.props.setFilter({cat1_id: parseInt(r.cat1_id, 10), cat2_id: parseInt(r.cat2_id, 10), cat3_id: parseInt(r.cat3_id, 10)});
                                // };
                                break;
                            default:
                                link = `/search`;
                                break;
                        }
                        const highlightedText = r.search_term// this.generateHighlightedText(r.matches[0].value, r.matches[0].indices);
                        return <Link key={index} to={link} onClick={() => {
                            if (typeof preClose === "function") {
                                preClose();
                            }
                            this.searchHandleClick();
                        }}><li dangerouslySetInnerHTML={{ __html: `<span>${(r.pretext ? r.pretext : '') + highlightedText}</span>` }}></li></Link>
                    })}
                </div>
            )
        }
        if (brands.length > 0) {
            html.push(
                <div key="brand-search">
                    <h2 className="search-header-category">แบรนด์แนะนำ</h2>
                    {_.map(brands, (r, index) => {
                        const item = r
                        let link = item.shop_in_shop ? item.link_name : `/shop/${item.search_term.replaceAll("/", "%2F")}`;

                        // const highlightedText = this.generateHighlightedText(r.matches[0].value, r.matches[0].indices);
                        // return <Link key={index} to={link} onClick={() => {this.searchHandleClick();}}><li dangerouslySetInnerHTML={{__html: `<span>${(r.item.pretext? r.item.pretext: '') + highlightedText}</span>`}}></li></Link>
                        return (
                            <Link key={index} to={link} onClick={() => { this.searchHandleClick(); }}>
                                <li>
                                    <div className="d-flex w-100 flex-row align-items-center">
                                        <div className="mr-2">
                                            <img alt="" src={item.image} style={{ height: "50px", width: "auto" }} />
                                        </div>
                                        <div className="content">{item.search_term}</div>
                                    </div>
                                </li>
                            </Link>
                        )
                    })}
                </div>
            );
        }
        if (items.length > 0) {
            html.push(
                <div key="item-search">
                    <h2 className="search-header-category">ผลิตภัณฑ์แนะนำ</h2>
                    {_.map(items, (r, index) => {
                        const item = r
                        let link = `/item/${item.value}`;
                        // const highlightedText = this.generateHighlightedText(r.matches[0].value, r.matches[0].indices);
                        return (
                            <Link key={index} to={link} onClick={() => {/*pixelTrack("Search", {search_string: this.state.keyword, content_ids: item.item_id, content_type: 'product'});*/ this.searchHandleClick(); }}>
                                <li>
                                    <div className="d-flex w-100 flex-row align-items-center">
                                        <div className="mr-2">
                                            <img alt="" src={item.image} style={{ height: "50px", width: "auto" }} />
                                        </div>
                                        <div className="content">{item.search_term}</div>
                                        <div className="ml-auto price">{moneyFormat(item.price)}</div>
                                    </div>
                                </li>
                            </Link>
                        )
                    })}
                </div>
            );
        }
        if (html.length > 0) {
            html.push(
                <div key="search-more" className="search-more">
                    <Link to={`/search/${this.state.keyword}`}>แสดงผลการค้นหาทั้งหมด</Link>
                </div>
            )
        }
        return html;
    }

    // setReadNotice(){
    //     this.props.updateUserNotification();
    // }

    render() {
        const { authenticated, profile, count_notice, translate, location: { pathname } } = this.props; //translate, history, data_notice,  currentLanguage, setActiveLanguage, 
        const { searchVisible, bigAnnounceBarVisible } = this.state; //topPos, direction, 
        const { listCloseTerms, showMobileMenu, announcement } = this.props;
        // let anonymousVisible = !authenticated && pathname === "/checkout"; //checkout && not_login
        // let scrollClass = ''
        // let order_notice = 0;
        const role_id = profile ? profile.role_id : -1;
        // if (direction === "down") {
        //     scrollClass = 'scrollup';
        // } else { 
        //     if (topPos > 300) {
        //         scrollClass = 'scrollup';
        //     } else {
        //         scrollClass = '';
        //     }
        // }
        const isPrideEvent = moment().isBetween("2022-06-20", "2022-06-30", "d", "[]");
        const logo = isPrideEvent ? "https://cdn.thebeautrium.com/web-image/logo_pride.webp" : "https://cdn.thebeautrium.com/web-image/logo_tw_btran.png"
        return (
            <header className={`bt-header bt-header--sticky-top`}>
                {Boolean(announcement) && <div className="bt-header-announce-1">
                    {announcement}
                </div>}
                {/* <div className={`bt-header-announce-2 ${bigAnnounceBarVisible? "visible": "hidden"}`}>
                </div> */}
                <div className="bt-header-top-mini d-none d-xl-flex">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 px-0 text-right">
                                {/* <div className="h-100 d-inline-flex justify-content-end align-items-center" style={{paddingRight: "40px"}}>
                                    <span className="link" onClick={this.props.showTrackOrder}>{translate('TRACKING_ORDER')}</span>
                                    <span className="" style={{marginLeft: "10px"}}>|</span>
                                    <Link to="/upload_receipt"><span className="link" style={{marginLeft: "10px"}}>{translate('CONFIRM_PAYMENT')}</span></Link>
                                </div>
                                <div className="currency_lang d-none d-xl-inline-flex position-relative align-items-center" ref={(e) => this.node = e}>
                                    <button className="btn dropdown-toggle" type="button" id="currLangButton" onClick={() => this.currLangPopupHandleClick()}>
                                        <span className="ml-2"><img alt="Country Flag" className="flag mr-3" src={currentLanguage.flag} /><span className="mr-3">|</span>THB</span>
                                    </button>
                                    {this.state.currLangPopupVisible && <div className="bt-dropdown row" style={{top: "25px"}}>
                                        <span className="header">Language</span>
                                        <div className='col-xl-12 text-left px-0'>
                                            <SelectBox options={languageOptions} selectedOption={_.filter(languageOptions, (l) => l.value === currentLanguage.code)} onChange={(v) => {this.props.setLanguagePreference(v.value); setActiveLanguage(v.value);}} />
                                        </div>
                                        <span className="header" style={{marginTop: "20px"}}>Currency</span>
                                        <div className='col-xl-12 text-left px-0'>
                                            <SelectBox options={currencyOptions} selectedOption={currencyOptions[0]} />
                                        </div>
                                    </div>}
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bt-header-top">
                    <div className="container">
                        <div className="row">
                            <div className="left-menu col-8 d-none d-xl-flex align-items-center">
                                <Link to="/" className="logo mr-4">
                                    <img alt="BEAUTRIUM Logo" src={logo} />
                                </Link>
                                <div className="d-inline-flex justify-content-end align-items-center" style={{ width: "350px" }} ref={e => this.searchContainer = e}>
                                    <div className="w-100">
                                        <form className="form-inline bt-search" onSubmit={(e) => {
                                            e.preventDefault();
                                            this.searchHandleClick();
                                            this.props.history.push({ pathname: '/shop', search: `?keyword=${this.state.keyword}` })
                                        }}>
                                            <div className="form-group w-100">
                                                <input id="header-search" type="text" className="form-control" placeholder="ค้นหา+" value={this.state.keyword} onChange={(e) => { this.setKeyword(e.target.value) }} onClick={this.searchCompleteHandleClick} />
                                                <span className="position-absolute search-icon" style={{ right: "15px" }} onClick={() => this.props.history.push({ pathname: '/shop', search: `?keyword=${this.state.keyword}` })}><FontAwesomeIcon icon={faSearch} /></span>
                                                <div className={`search-autocomplete ${(this.state.keyword !== '' && this.state.searchCompleteVisible) ? "" : "hidden"}`}>
                                                    <ul>
                                                        {listCloseTerms && this.renderCloseTermsv2(listCloseTerms)}
                                                    </ul>
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                            <div className="right-menu col-4 text-right d-none d-xl-block">
                                <div className="d-flex justify-content-end align-items-center">
                                    <div id="login-profile" className="d-none d-xl-block" ref={n => { this.accountBox = n }}>
                                        {!authenticated &&
                                            <span className="link user-link" onClick={() => this.props.showAuthenticationPopup(true)}>
                                                <div className="d-inline-flex flex-row align-items-center justify-content-end user-icon">
                                                    <IconAccount color="#fff" />
                                                    <span>{translate('LOGIN').toUpperCase()} / {translate('SIGN_UP').toUpperCase()}</span>
                                                    <FontAwesomeIcon icon={faChevronDown} />
                                                </div>
                                            </span>
                                        }
                                        {(authenticated && profile) &&
                                            <div className="position-relative">
                                                <span className="link user-link" onClick={() => this.accountMenuHandleClick()}>
                                                    <div className="d-inline-flex flex-row align-items-center justify-content-end user-icon">
                                                        <IconAccount color="#fff" />
                                                        <span>{translate('HI')} {profile.first_name}</span>
                                                        <FontAwesomeIcon icon={faChevronDown} />
                                                    </div>

                                                    {this.state.accountMenuVisible &&
                                                        <div className="bt-dropdown account-menu row" onClick={(e) => { e.stopPropagation() }}>
                                                            <h4>{translate('ACCT_MY_ACCOUNT')}</h4>
                                                            <div className="menu">
                                                                <ul>
                                                                    {_.map(ACCOUNT_MENU, (menu, i) => {
                                                                        if (!menu.disabled) {
                                                                            return (
                                                                                <li key={"account_menu_" + i + menu.key + menu.name}>
                                                                                    <Link to={menu.link}>
                                                                                        <div>
                                                                                            {menu.key
                                                                                                ? translate(menu.key)
                                                                                                : menu.name}
                                                                                        </div>
                                                                                    </Link>
                                                                                </li>)
                                                                        } else {
                                                                            return null;
                                                                        }
                                                                    })}
                                                                    {/* <li><Link to="/account/profile"><div>{translate('ACCT_MY_INFO')}</div></Link></li> */}
                                                                    {/* <li>
                                                                <Link to="/account/orders"><div>{translate('ACCT_MY_ORDERS')}
                                                                {order_count > 0 ?
                                                                    <span className="bg-primary ml-2 notice-count">{order_count}</span>
                                                                    : 
                                                                    " "
                                                                }</div>
                                                                </Link>
                                                            </li> */}
                                                                    {/* <li><Link to="/account/wishlist"><div>{translate('ACCT_MY_FAVORITE')}</div></Link></li> */}
                                                                    {/* <li><Link to="/account/address"><div>{translate('ACCT_MY_ADDRESS')}</div></Link></li> */}
                                                                    {/* <li><Link to="/account/coupon"><div>{translate('ACCT_MY_COUPON')}</div></Link></li> */}
                                                                    {/* <li><Link to="/account/credit_card"><FontAwesomeIcon icon={["fas", "credit-card"]} />ช่องทางการชำระเงิน</Link></li> */}
                                                                    {/* <li><Link to="/account/coins"><div>{translate('ACCT_REWARD_POINT')}</div></Link></li> */}
                                                                    {/* <li><Link to="/account/notification"><div>{translate('ACCT_NOTIFICATION')}</div></Link></li> */}

                                                                    {[0, 4, 8].includes(role_id) && <li><Link to="/adminblog"><div>Blog Editor</div></Link></li>}
                                                                    {[0, 4, 80].includes(role_id) && <li><Link to="/chat_order"><div>Create Order</div></Link></li>}
                                                                </ul>
                                                            </div>
                                                            <div className="menu" style={{ paddingTop: 10 }}>
                                                                <ul>
                                                                    <li><Link to="/upload_receipt"><div>{translate('upload_receipt')}</div></Link></li>
                                                                </ul>
                                                            </div>
                                                            <div className="signout link" onClick={() => this.props.signout()}>
                                                                <span className="color-black">{translate('SIGN_OUT')}</span>
                                                            </div>
                                                        </div>}
                                                </span>
                                                {count_notice > 0 ?
                                                    <span className="bg-primary position-absolute notice-count">{count_notice}</span> : ""
                                                }
                                            </div>
                                        }
                                    </div>
                                    <div className="h-100 d-inline-flex justify-content-end align-items-center right-icons">
                                        <Link to="/store_locations"><div className="location-icon"><FontAwesomeIcon icon={faMapMarkerAlt} /></div></Link>
                                        <HeaderCart willLock={false} authenticated={authenticated} updateHeight={bigAnnounceBarVisible} />
                                    </div>
                                </div>
                            </div>
                            <div className="left-menu col-6 d-flex d-xl-none">
                                <span className={`bt-hamburger ${showMobileMenu ? "open" : ""}`} onClick={() => { this.props.toggleResponsiveMenu() }}>
                                    <IconHamburger color="#fff" />
                                    {count_notice > 0 ?
                                        <span className="bg-primary position-absolute notice-count" style={{ top: '-10px', left: '65%' }}>{count_notice}</span> : ""
                                    }
                                    <span className="bt-hamburger-plus"><FontAwesomeIcon icon={faPlus} /></span>
                                </span>
                                <span className="bt-search-mobile" onClick={this.searchHandleClick}><FontAwesomeIcon icon={faSearch} /></span>
                            </div>
                            <div className="right-menu col-6 d-flex d-xl-none justify-content-end">
                                {/* <span className="account-mobile"><Link to={authenticated? "/account/profile": "/login"}><IconAccount /></Link></span> */}
                                <div className="right-icons">
                                    <Link to="/store_locations"><div className="location-icon"><FontAwesomeIcon icon={faMapMarkerAlt} /></div></Link>
                                    <HeaderCart willLock={true} />
                                </div>
                            </div>
                            <Link to="/" className="logo d-block d-xl-none">
                                <img alt="BEAUTRIUM Logo" src={logo} />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="bt-header-menu d-none d-xl-block">
                    <div className="container h-100">
                        <div className="row align-items-center h-100">
                            <div className="col-12">
                                <ul className="menu mb-0 pl-0">
                                    <li className={`mega-menu ${this.state.shopMenuVisible || pathname === "/shop" ? 'active' : ''}`} onMouseEnter={(e) => { this.handleMouseLeave(true) }} onMouseLeave={(e) => { this.handleMouseLeave(false) }} onClick={() => this.megaMenuHandleClick()}  >
                                        <Link to="/shop" onClick={() => { this.props.setFilter({}); this.props.setSort({ value: 'best_sellers' }) }}><div>{translate('SHOP_CATEGORY')}</div></Link>
                                        <HeaderMegaMenu visible={this.state.shopMenuVisible} ref={megaMenu => { this.megaMenu = megaMenu; }} onMouseClick={(e) => { this.setState({ shopMenuVisible: false }) }} onMouseEnter={(e) => { this.handleMouseLeave(true) }} onMouseLeave={(e) => { this.handleMouseLeave(false) }} location={this.props.location} />
                                    </li>
                                    <li className={`${pathname === "/deals" && "active"}`}><Link onClick={() => { this.props.setFilter({}) }} to="/deals">{translate('PROMO')}</Link></li>
                                    {/* {moment().isBetween("2021-06-05 16:00:00", "2021-06-06 23:59:59", "s", "[]") && <li className={`${pathname === "/flashsale" && "active"}`}><Link to="/flashsale">FLASH SALE</Link></li>} */}
                                    <li><Link to="/shop" onClick={() => { this.props.setFilter({}); this.props.setSort({ value: 'new_arrivals' }) }}>{translate('NEW_IN')}</Link></li>
                                    <li className={`${pathname === "/brands" && "active"} pre-last`}><Link to="/brands">{translate('BRANDS')}</Link></li>
                                    {moment().isSameOrAfter("2024-08-07 00:00:00", 'd') && <li className={`${pathname === "/exclusiveedition" && "active"}`}><Link to="/exclusiveedition">Exclusive Edition</Link></li>}
                                    <li className="pre-last"><Link to="/blogs">{translate('BLOGS')}</Link></li>
                                    <li className="pre-last"><Link to="/campaign/giveaway">{translate('CAMPAIGN.GIVEAWAY')}</Link></li>
                                    {/* <li className="vertical-border"></li> */}
                                    {/* <li className="last"><Link to="/aboutus" id="link-about">{translate('ABOUT_US')}</Link></li> */}
                                </ul>
                            </div>
                            {/* <div className="col-3 text-right">
                                
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className={`bt-search-mobile-div d-block d-xl-none ${searchVisible ? "" : "hidden"} position-relative`} ref={e => this.searchBox = e}>
                    <form className="form-inline bt-search" onSubmit={(e) => { e.preventDefault(); this.searchHandleClick(); this.props.history.push({ pathname: '/shop', search: `?keyword=${this.state.keyword}` }) }}>
                        <div className="form-group w-100">
                            <input id="header-search-mobile" type="text" className="form-control" placeholder="ค้นหา+" value={this.state.keyword} onChange={(e) => { this.setKeyword(e.target.value) }} onClick={this.searchCompleteHandleClick} />
                            <span className="position-absolute search-icon" style={{ right: "15px", top: "50%", transform: 'translateY(-50%)', color: "#231f20" }} onClick={() => { this.searchHandleClick(); this.props.history.push({ pathname: '/shop', search: `?keyword=${this.state.keyword}` }) }}><FontAwesomeIcon icon={faSearch} /></span>
                        </div>
                    </form>
                </div>
                <div className={`bt-backdrop ${(searchVisible) ? "d-block d-xl-none" : "d-none"}`} style={{ position: "absolute", width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.6)", zIndex: -1, }} onClick={this.searchCompleteHandleClick}>
                </div>
                <div className={`search-autocomplete search-autocomplete-mobile d-block d-xl-none ${(this.state.keyword !== '' && this.state.searchCompleteVisible) ? "" : "hidden"}`}>
                    <ul>
                        {listCloseTerms && this.renderCloseTermsv2(listCloseTerms)}
                    </ul>
                </div>
            </header>
        )
    }
}

function mapStateToProps(state) {
    return {
        // authenticated: state.auth.authenticated,
        profile: state.prof.profile,
        data_notice: state.notice.data_notice,
        count_notice: state.notice.count_notice,
        order_count: state.notice.order_count,
        update_notice: state.notice.updateUserNotification,
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale),
        listCloseTerms: state.search.listCloseTerms,
        showMobileMenu: state.common.show_responsive_menu,
        categories: state.itemCategories.categories,
    }
}
export default withRouter(connect(mapStateToProps, { signout, setActiveLanguage, showAuthenticationPopup, showResponsiveMenu, toggleResponsiveMenu, setSort, setFilter, closeTerm, search, setLanguagePreference, getUserNotification, updateUserNotification })(Header));